var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"size":"medium","clearable":"","placeholder":"search by name or reference"},on:{"input":function($event){!_vm.content?_vm.$emit('input',null):null}},nativeOn:{"keyup":function($event){return _vm.monitor.apply(null, arguments)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }